import {
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { EnvironmentModule } from '@epicuro-next/platform/environment';

import { IonicLoaderService } from './service/ionic-loader.service';

export function loadIonic(ionicLoaderService: IonicLoaderService) {
  return () => {
    ionicLoaderService
      .initialize()
      .toPromise()
      .finally(() => Promise.resolve());
  };
}

@NgModule({
  imports: [EnvironmentModule],
  providers: [IonicLoaderService],
})
export class IonicLoaderModule {
  public static forRoot(): ModuleWithProviders<IonicLoaderModule> {
    return {
      ngModule: IonicLoaderModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = loadIonic(inject(IonicLoaderService));
          return initializerFn();
        }),
      ],
    };
  }
}
